import { Box } from "@mui/system";

const Map = () => {
  return (
    <>
      <Box
        sx={{
          height: {
            xs: "300px", // For extra small screens (mobile)
            sm: "300px", // For small screens (tablets)
            md: "100%", // For medium screens (laptops)
            lg: "100%", // For large screens (desktops)
          },
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2926.531559011028!2d-81.23709292408005!3d42.81938420595945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882e5f3f59a1e601%3A0xb63c12a288a0304e!2s11503%20Wonderland%20Rd%2C%20St%20Thomas%2C%20ON%20N5P%203T1!5e0!3m2!1sen!2sca!4v1753881155218!5m2!1sen!2sca"
          width="100%"
          height="100%"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </Box>
    </>
  );
};
export default Map;
